import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { PROPOSITO_ALMA_NAME, PROPOSITO_ALMA_STEPS } from './combo-config'

const PropositoAlma = () => (
    <ComboWizard
        comboName={PROPOSITO_ALMA_NAME}
        steps={PROPOSITO_ALMA_STEPS}
        bgClass="bg-proposito-alma"
        interpretStep={interpretStep}
        consultaPlaceholder="Inquietud del consultante sobre propósito, vocación o camino del alma (opcional). Se usará en las 3 tiradas del combo."
    />
)

export default PropositoAlma
